import { Loader2 } from "lucide-react";

import { LoadingTimeoutNotice } from "@/components/LoadingTimeoutNotice";

export default function AuthGateFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-canvas p-4 text-ink">
      <div className="flex flex-col items-center gap-3 rounded-md border border-line bg-surface/80 px-8 py-6">
        <Loader2 className="h-6 w-6 animate-spin text-action" />
        <p className="text-sm font-medium text-ink">正在確認登入狀態...</p>
      </div>
      <div className="mt-4">
        <LoadingTimeoutNotice />
      </div>
    </div>
  );
}
